import crud from "../../../../stores/crud";

const getDefaultState = () => {
	return {
		...crud.state,
		routes: {
			index: "teams",
			show: "teams/:team",
		},
	};
};

const state = getDefaultState();

export default {
	namespaced: true,
	state,
	actions: {
		...crud.actions,
	},
	mutations: {
		...crud.mutations,
	},
	getters: {
		...crud.getters,
	},
};
